/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_MoreInputs */

const en_cad_compare_more = /** @type {(inputs: Cad_Compare_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the full comparison`)
};

/**
* | output |
* | --- |
* | "Read the full comparison" |
*
* @param {Cad_Compare_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_more = /** @type {((inputs?: Cad_Compare_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_more(inputs)
});
export { cad_compare_more as "cad.compare.more" }